<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow">
      <h2 class="text-2xl font-bold text-center">Reset Password</h2>
      <div v-if="ssoMessage" class="p-4 bg-blue-50 border border-blue-200 rounded-md">
        <p class="text-sm text-blue-700">{{ ssoMessage }}</p>
      </div>
      <div v-else-if="success">If an account exists for {{email}}, a password reset link was sent. Please check your email.</div>
      <form v-if="!success && !ssoMessage" @submit.prevent="register">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium" for="email">Please enter email:</label>
            <input
              id="email"
              v-model="email"
              class="w-full px-3 py-2 border rounded"
              type="email"
              required
            />
            <Field_Errors :received_errors="errors.email" />
            <Field_Errors :received_errors="errors.non_field_errors" />
            <button class=" text-center w-full border py-2 px-4 rounded bg-gray-600 text-white font-semibold">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Field_Errors from '@/components/widgetcomponents/Field_Errors.vue';
import { makeAllauthRequestAndParseErrors } from '@/utils/auth';
import { emailLookup } from '@/services/api/auth';

export default {
  components: {
    Field_Errors,
  },
  data() {
    return {
      email:'',
      errors: {},
      success: false,
      ssoMessage: '',
    }
  },
  methods: {
    async register() {
      try {
        this.errors = {}
        this.ssoMessage = ''
        const lookup = await emailLookup(this.email)
        if (lookup.method === 'sso') {
          this.ssoMessage = 'This account uses Microsoft SSO. Please sign in using your organization\'s SSO login instead.'
          return
        }
        await makeAllauthRequestAndParseErrors({
          method: 'post',
          url: '_allauth/browser/v1/auth/password/request',
          data: { email: this.email },
        })
        this.success = true
      } catch (error) {
        if (error.fieldBasedErrors) {
          this.errors = error.fieldBasedErrors;
        } else {
          throw error;
        }
      }
    }
  },
}
</script>
